@if (showGraph()) {
<div class="supervisor-dialog-backdrop" (click)="onShowGraphClicked()"></div>
<dialog class="supervisor-dialog-graph" open>
  <div
    style="
      text-align: center;
      margin-bottom: 1rem;
      font-weight: bold;
      color: white;
    "
  >
    <h3>
      Graphs for {{ target?.TargetName }} ({{
        targetTypeToDisplay(target?.TargetType)
      }})
    </h3>
  </div>
  <app-target-graph
    [patientID]="patientID()"
    [selectedTargets]="[target!]"
  ></app-target-graph>
</dialog>
} @if (showData()) {
<div class="supervisor-dialog-backdrop" (click)="onShowDataClicked()"></div>
<dialog class="supervisor-dialog" style="max-width: 80rem" open>
  <div
    style="
      text-align: center;
      margin-bottom: 1rem;
      font-weight: bold;
      color: white;
    "
  >
    <h3>Raw Data for {{ target?.TargetName }}</h3>
  </div>
  <app-rawdata
    [defaultPromptCodes]="target?.AllPromptCodes"
    [selectedTarget]="target!"
  ></app-rawdata>
</dialog>
} @if (!isExpanded) {
<div
  class="container"
  [style]="{
    'border-radius': '15px',
    padding: '5px',
    marginTop: '5px',
    backgroundColor: getBackgroundColor()
  }"
  [ngClass]="{
    'target-closed': isClosed(),
    'target-open': !isClosed(),
    'target-selected': isTargetSelected()
  }"
>
  <div
    class="row h-4rem align-items-center position-relative"
    [class]="isSelecting ? 'cursor-pointer' : ''"
    (click)="isSelecting ? toggleCollapsed() : null"
    id="toggleCollapseButton-{{ target?.TargetName }}"
  >
    <div
      class="col-3 d-flex align-items-center"
      role="button"
      (click)="!isSelecting ? toggleCollapsed() : null"
    >
      <span
        class="fs-8"
        style="font-size: 20px; font-weight: bold; white-space: pre-wrap"
        [style.color]="getTintColor()"
        >{{ targetNameForDisplay() }}</span
      >
      <i
        class="pi pi-circle-fill ms-2"
        style="
          font-size: 1rem;
          color: #9382ad;
          border: 1px solid;
          border-radius: 50%;
        "
        [style.border-color]="getTintColor()"
        *ngIf="targetAlerts().length > 0"
      ></i>
    </div>
    <div
      class="col-6 d-flex justify-content-center text-center"
      role="button"
      (click)="!isSelecting ? toggleCollapsed() : null"
    >
      <span
        class="fs-8"
        [style.color]="getTintColor()"
        style="font-weight: bold"
        >{{ "SD: " + target?.DiscriminativeStimulus }}</span
      >
    </div>
    <div class="col-2 d-flex justify-content-end gap-3">
      <p-tag
        id="deleted-tag"
        severity="danger"
        value="Deleted"
        class="ms-2"
        *ngIf="target?.IsDeleted"
      />
      <p-tag
        id="archived-tag"
        severity="warning"
        value="Archived"
        class="ms-2"
        *ngIf="target?.IsArchived"
      />
    </div>
    <div class="col-1 d-flex justify-content-end gap-3 position-relative">
      <i
        class="pi pi-flag-fill"
        style="font-size: 1rem"
        [style.color]="target?.IsSpecialFavorite ? 'darkgreen' : 'lightgreen'"
        [title]="target?.IsSpecialFavorite ? 'Special Favorite' : 'Favorite'"
        *ngIf="showFlag()"
      ></i>
      <i
        class="pi pi-circle-fill"
        role="button"
        style="font-size: 1rem; border: 2px solid; border-radius: 50%"
        [style.border-color]="getTintColor()"
        [style.color]="getCircleColor()"
        [style.border-radius]="'50%'"
        [style.z-index]="1"
        [title]="getCircleTooltip()"
        *ngIf="showCircle()"
        (click)="toggleStatusCircleEdit($event)"
      ></i>
      @if(orderMode === 'custom' && isEditMode) { } @else {
      <i
        class="pi pi-arrow-up"
        [style.color]="getTintColor()"
        style="font-size: 1rem"
        role="button"
        (click)="toggleCollapsed()"
      ></i>
      } @if(showStatusCircleEdit){
      <div class="target-status-edit">
        <i
          class="target-status-edit-close"
          role="button"
          (click)="toggleStatusCircleEdit($event)"
          >x</i
        >
        <div class="control-row">
          <div class="control no-margin">
            <label for="targetStatus">Target Status:</label>
            <p-dropdown
              #dropdownTargetStatus
              autoWidth="false"
              [style]="{ width: '100%' }"
              appendTo="body"
              [options]="targetStatuses"
              name="targetStatus"
              [(ngModel)]="newTargetStatus"
              optionValue="value"
              optionLabel="text"
            >
            </p-dropdown>
          </div>
          <button
            class="btn btn-primary float-right mt-2"
            style="color: #ffffff"
            (click)="updateTargetStatus()"
          >
            Update
          </button>
        </div>
      </div>
      }
    </div>
  </div>

  <div class="row h-4rem align-items-center">
    <div class="col-4">
      <span
        class="fs-8"
        [style.color]="getTintColor()"
        style="font-weight: bold"
        >{{ "Type: " + targetTypeToDisplay(target?.TargetType) }}</span
      >
    </div>
    <div class="col-4 d-flex justify-content-center">
      <span
        *ngIf="false"
        class="fs-8"
        [style.color]="getTintColor()"
        style="font-weight: bold"
        >{{ "Auto-Open Order: " + "?" }}</span
      >
    </div>
    <div class="col-4 d-flex justify-content-end">
      <span
        class="fs-8"
        [style.color]="getTintColor()"
        style="font-weight: bold"
      >
        {{
          shouldDisplayMasteredDate()
            ? "Mastered Date: " +
              (target?.DateMastered ? (target?.DateMastered | date) : "None")
            : "Opened Date: " +
              (target?.DateOpened ? (target?.DateOpened | date) : "None")
        }}
      </span>
    </div>
  </div>
</div>

} @else {
<div
  class="container"
  [style]="{
    border: isClosed() ? '2px solid rgb(173, 173, 173)' : '2px solid #719eb6',
    'border-radius': '15px',
    marginTop: '25px',
    paddingLeft: '0px',
    paddingRight: '0px'
  }"
>
  <div
    class="row h-4rem align-items-center w-100"
    style="border-radius: 10px 10px 0 0"
    [style.background-color]="getBackgroundColor()"
  >
    <div
      class="col-4 d-flex align-items-center"
      role="button"
      (click)="toggleCollapsed()"
    >
      <span
        class="fs-8"
        [style.color]="getTintColor()"
        style="font-size: 20px; font-weight: bold"
        >{{ targetNameForDisplay() }}</span
      >
      <i
        class="pi pi-circle-fill ms-2"
        style="
          font-size: 1rem;
          color: #9382ad;
          border: 1px solid;
          border-color: getTintColor();
          border-radius: 50%;
        "
        *ngIf="targetAlerts().length > 0"
      ></i>
    </div>
    <div
      class="col-4 d-flex justify-content-center"
      role="button"
      (click)="toggleCollapsed()"
    >
      <span
        class="fs-8"
        [style.color]="getTintColor()"
        style="font-weight: bold"
        >{{ "SD: " + target?.DiscriminativeStimulus }}</span
      >
    </div>
    <div
      class="col-3 d-flex justify-content-end gap-3"
      role="button"
      (click)="toggleCollapsed()"
    >
      <p-tag
        id="deleted-tag"
        severity="danger"
        value="Deleted"
        class="ms-2"
        *ngIf="target?.IsDeleted"
      />
      <p-tag
        id="archived-tag"
        severity="warning"
        value="Archived"
        class="ms-2"
        *ngIf="target?.IsArchived"
      />
    </div>
    <div class="col-1 d-flex justify-content-end gap-3 position-relative">
      <i
        class="pi pi-flag-fill"
        style="font-size: 1rem"
        [style.color]="target?.IsSpecialFavorite ? 'darkgreen' : 'lightgreen'"
        [title]="target?.IsSpecialFavorite ? 'Special Favorite' : 'Favorite'"
        *ngIf="showFlag()"
      ></i>
      <i
        class="pi pi-circle-fill"
        style="font-size: 1rem; border: 2px solid; border-radius: 50%"
        [style.border-color]="getTintColor()"
        [style.color]="getCircleColor()"
        (click)="toggleStatusCircleEdit($event)"
        [style.border-radius]="'50%'"
        [title]="getCircleTooltip()"
        *ngIf="showCircle()"
      ></i>
      @if(orderMode === 'custom' && isEditMode) { } @else {
      <i
        class="pi pi-arrow-down"
        [style.color]="getTintColor()"
        style="font-size: 1rem"
        role="button"
        (click)="toggleCollapsed()"
      ></i>
      } @if(showStatusCircleEdit){
      <div class="target-status-edit">
        <i
          class="target-status-edit-close"
          role="button"
          (click)="toggleStatusCircleEdit($event)"
          >x</i
        >
        <div class="control-row">
          <div class="control no-margin">
            <label for="targetStatus">Target Status:</label>
            <p-dropdown
              autoWidth="false"
              [style]="{ width: '100%' }"
              appendTo="body"
              [options]="targetStatuses"
              name="targetStatus"
              [(ngModel)]="newTargetStatus"
              optionValue="value"
              optionLabel="text"
            >
            </p-dropdown>
          </div>
          <button
            class="btn btn-primary float-right mt-2"
            style="color: #ffffff"
            (click)="updateTargetStatus()"
          >
            Update
          </button>
        </div>
      </div>
      }
    </div>
  </div>

  @if (targetAlerts().length > 0) {
  <div class="row mt-2">
    <div class="col-12">
      <div
        class="alert"
        role="alert"
        style="background-color: #9382ad; color: white"
      >
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <i class="pi pi-exclamation-triangle me-2"></i>
            <span class="fw-bold">{{ targetAlerts()[0].sender }}:</span>
            <span class="text-truncate w-80 text-wrap" style="color: white">
              {{ targetAlerts()[0].message }}
            </span>
          </div>
          <span
            class="fw-bold"
            style="color: white; cursor: pointer"
            (click)="dismissAlertButtonClicked(targetAlerts()[0])"
          >
            Dismiss
          </span>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- new layout-->

  <div class="row mt-2">
    <div class="col-10">
      <!-- Half width rows -->
      <div class="row mb-2">
        <div class="col-6">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6">Type:</span>
            <span class="text-truncate" style="color: #719eb6">{{
              targetTypeToDisplay(target?.TargetType)
            }}</span>
          </div>
        </div>
        <div class="col-6">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6">Mastery Type:</span>
            <span class="text-truncate" style="color: #719eb6">{{
              target?.ShouldMasterAutomatic ? "Automatic" : "Manual"
            }}</span>
          </div>
        </div>
      </div>

      <!-- Half width rows -->
      <div class="row mb-2">
        <div class="col-6 position-relative">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6">Programs:</span>
            <div
              class="d-flex justify-content-end"
              role="button"
              (click)="toggleProgramsEdit($event)"
            >
              <span
                class="text-truncate"
                style="color: #719eb6; margin-right: 0.5rem"
                >{{ includedPrograms }}</span
              >
              <div style="color: #719eb6">
                <i class="pi pi-pencil m-0 p-0"></i>
              </div>
            </div>
          </div>
          @if(showProgramsEdit){
          <div class="target-status-edit">
            <i
              class="target-status-edit-close"
              role="button"
              (click)="toggleProgramsEdit($event)"
              >x</i
            >
            <div class="control-row">
              <div class="control no-margin">
                <label for="targetStatus">Programs:</label>
                <p-multiSelect
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  appendTo="body"
                  [options]="possiblePrograms()"
                  name="programs"
                  [(ngModel)]="selectedProgramIDs"
                  optionValue="ID"
                  optionLabel="ProgramName"
                  [filter]="true"
                  [filterBy]="'ProgramName'"
                >
                </p-multiSelect>
              </div>
              <button
                class="btn btn-primary float-right mt-2"
                style="color: #ffffff"
                (click)="updateTargetPrograms()"
              >
                Update
              </button>
            </div>
          </div>
          }
        </div>

        @if (!isCurrency()) {
        <div class="col-6 position-relative">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <div class="d-flex flex-column align-items-start">
              <span class="fw-bold" style="color: #719eb6"
                >Session Trial Count:</span
              >
              <button
                pButton
                class="p-button-outlined side-menu-button2 mt-1"
                (click)="goToStaffManagementReportForTarget()"
              >
                Staff Report
              </button>
            </div>
            <div
              class="d-flex justify-content-end"
              role="button"
              (click)="toggleSessionTrialCountEdit($event)"
            >
              <span
                class="text-truncate"
                style="color: #719eb6; margin-right: 0.5rem"
                >{{ target?.DesiredTrials || "None" }}</span
              >
              <div style="color: #719eb6">
                <i class="pi pi-pencil m-0 p-0"></i>
              </div>
            </div>
          </div>
          @if(showSessionTrialCountEdit){
          <div class="target-status-edit">
            <i
              class="target-status-edit-close"
              role="button"
              (click)="toggleSessionTrialCountEdit($event)"
              >x</i
            >
            <div class="control-row">
              <div class="control no-margin">
                <label for="targetStatus">Session Trial Count:</label>
                <input
                  type="number"
                  class="form-control"
                  [(ngModel)]="sessionTrialCount"
                />
              </div>
              <button
                class="btn btn-primary float-right mt-2"
                style="color: #ffffff"
                (click)="updateTargetSessionTrialCount()"
              >
                Update
              </button>
            </div>
          </div>
          }
        </div>
        } @else {
        <div class="col-6 position-relative">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6">Current Balance:</span>
            <span class="text-truncate" style="color: #719eb6; margin-right: 0.5rem">
              {{ (target?.CurrencySymbol || '$') + (target?.CurrentBalance ?? target?.StartingBalance ?? 0) }}
            </span>
          </div>
        </div>
        }
      </div>

      <!-- Half width rows -->
      <div class="row mb-2">
        <div class="col-6 position-relative">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6">Playlists:</span>
            <div
              class="d-flex justify-content-end"
              role="button"
              (click)="togglePlaylistsEdit($event)"
            >
              <span
                class="text-truncate"
                style="color: #719eb6; margin-right: 0.5rem"
                >{{ includedPlaylists }}</span
              >
              <div style="color: #719eb6">
                <i class="pi pi-pencil m-0 p-0"></i>
              </div>
            </div>
          </div>
          @if(showPlaylistsEdit){
          <div class="target-status-edit">
            <i
              class="target-status-edit-close"
              role="button"
              (click)="togglePlaylistsEdit($event)"
              >x</i
            >
            <div class="control-row">
              <div class="control no-margin">
                <label for="targetStatus">Playlists:</label>
                <p-multiSelect
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  appendTo="body"
                  [options]="possiblePlaylists()"
                  name="playlists"
                  [(ngModel)]="selectedPlaylistIDs"
                  optionValue="ID"
                  optionLabel="PlaylistName"
                  [filter]="true"
                  [filterBy]="'PlaylistName'"
                >
                </p-multiSelect>
              </div>
              <button
                class="btn btn-primary float-right mt-2"
                style="color: #ffffff"
                (click)="updateTargetPlaylists()"
              >
                Update
              </button>
            </div>
          </div>
          }
        </div>
        <div class="col-6">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6"
              >Status at a Glance:</span
            >
            <span class="text-truncate" style="color: #719eb6">{{
              getCircleTooltip()
            }}</span>
          </div>
        </div>
      </div>

      <!-- Half width rows -->
      <div class="row mb-2">
        <!-- Target Status -->
        <div class="col-6 position-relative">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6">Target Status:</span>
            <div
              class="d-flex justify-content-end"
              role="button"
              (click)="toggleStatusEdit($event)"
            >
              <span
                class="text-truncate"
                style="color: #719eb6; margin-right: 0.5rem"
                >{{ getStatusName(target?.TargetStatus) }}
              </span>
              <div style="color: #719eb6">
                <i class="pi pi-pencil m-0 p-0"></i>
              </div>
            </div>
          </div>
          @if(showStatusEdit){
          <div class="target-status-edit">
            <i
              class="target-status-edit-close"
              role="button"
              (click)="toggleStatusEdit($event)"
              >x</i
            >
            <div class="control-row">
              <div class="control no-margin">
                <label for="targetStatus">Target Status:</label>
                <p-dropdown
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  appendTo="body"
                  [options]="targetStatuses"
                  name="targetStatus"
                  [(ngModel)]="newTargetStatus"
                  optionValue="value"
                  optionLabel="text"
                >
                </p-dropdown>
              </div>
              <button
                class="btn btn-primary float-right mt-2"
                style="color: #ffffff"
                (click)="updateTargetStatus()"
              >
                Update
              </button>
            </div>
          </div>
          }
        </div>
        <!-- Opened/Mastered Date -->
        <div class="col-6 position-relative">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6">
              {{
                shouldDisplayMasteredDate() ? "Mastered Date:" : "Opened Date:"
              }}
            </span>
            <div
              class="d-flex justify-content-end"
              role="button"
              (click)="toggleOpenedDateEdit($event)"
            >
              <span
                class="text-truncate"
                style="color: #719eb6; margin-right: 0.5rem"
                >{{
                  shouldDisplayMasteredDate()
                    ? target?.DateMastered
                      ? (target?.DateMastered | date)
                      : "None"
                    : target?.DateOpened
                    ? (target?.DateOpened | date)
                    : "None"
                }}</span
              >
              <div style="color: #719eb6">
                <i class="pi pi-pencil m-0 p-0"></i>
              </div>
            </div>
          </div>
          @if(showOpenedDateEdit){
          <div class="target-status-edit">
            <i
              class="target-status-edit-close"
              role="button"
              (click)="toggleOpenedDateEdit($event)"
              >x</i
            >
            <div class="control-row">
              <div class="control no-margin">
                <label for="targetStatus">{{
                  shouldDisplayMasteredDate()
                    ? "Mastered Date:"
                    : "Opened Date:"
                }}</label>
                <input
                  type="date"
                  class="form-control"
                  [(ngModel)]="newOpenedDate"
                />
              </div>
              <button
                class="btn btn-primary float-right mt-2"
                style="color: #ffffff"
                (click)="updateTargetOpenedDate()"
              >
                Update
              </button>
            </div>
          </div>
          }
        </div>
      </div>

      <!-- Half width rows -->
      <div class="row mb-2">
        <!-- Skills -->
        <div class="col-6 position-relative">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6">Skills:</span>
            <div
              class="d-flex justify-content-end"
              role="button"
              (click)="toggleSkillsEdit($event)"
            >
              <span
                class="text-truncate"
                style="color: #719eb6; margin-right: 0.5rem"
                >{{ includedSkillArea }}</span
              >
              <div style="color: #719eb6">
                <i class="pi pi-pencil m-0 p-0"></i>
              </div>
            </div>
          </div>
          @if(showSkillsEdit){
          <div class="target-status-edit">
            <i
              class="target-status-edit-close"
              role="button"
              (click)="toggleSkillsEdit($event)"
              >x</i
            >
            <div class="control-row">
              <div class="control no-margin">
                <label for="targetStatus">Skills:</label>
                <p-dropdown
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  appendTo="body"
                  [options]="possibleSkills()"
                  name="skills"
                  [(ngModel)]="selectedSkillID"
                  optionValue="ID"
                  optionLabel="SkillAreaName"
                  [filter]="true"
                  [filterBy]="'SkillAreaName'"
                >
                </p-dropdown>
              </div>
              <button
                class="btn btn-primary float-right mt-2"
                style="color: #ffffff"
                (click)="updateTargetSkills()"
              >
                Update
              </button>
            </div>
          </div>
          }
        </div>
        <!-- Last Changed Date -->
        <div class="col-6 position-relative">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6"
              >Last Changed Date:</span
            >
            <span class="text-truncate" style="color: #719eb6">{{
              target?.LastChangedDate | date
            }}</span>
          </div>
        </div>
      </div>

      <!-- Half width rows -->
      @if (shouldShowMaintenanceSummary()) {
      <div class="row mb-2">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6"
              >Current Maintenance Criteria Level:</span
            >
            <span class="text-truncate" style="color: #719eb6">{{
              maintenanceSummary()
            }}</span>
          </div>
        </div>
      </div>
      }

      <!-- Half width rows -->
      <div class="row mb-2">
        <!-- Favorite -->
        <div class="col-6">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6">Favorite:</span>
            <p-toggleButton
              [(ngModel)]="target!.IsFavorite"
              (onChange)="updateTargetFavorite()"
              [style]="{
                width: '50px',
                border: '1px solid #719eb6',
                color: '#719eb6',
                backgroundColor: '#fff',
                borderRadius: '10px',
                fontWeight: 'bold'
              }"
              onLabel="Yes"
              offLabel="No"
              [disabled]="isSelecting"
            ></p-toggleButton>
          </div>
        </div>
        <!-- Special Favorite -->
        <div class="col-6">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6"
              >Special Favorite:</span
            >
            <p-toggleButton
              [(ngModel)]="target!.IsSpecialFavorite"
              (onChange)="updateTargetSpecialFavorite()"
              [style]="{
                width: '50px',
                border: '1px solid #719eb6',
                color: '#719eb6',
                backgroundColor: '#fff',
                borderRadius: '10px',
                fontWeight: 'bold'
              }"
              onLabel="Yes"
              offLabel="No"
              [disabled]="isSelecting"
            >
            </p-toggleButton>
          </div>
        </div>
      </div>

      <!-- Half width rows -->
      @if(shouldShowAlarmOptions()){
      <div class="row mb-2">
        <div class="col-6">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6">Alarm Option:</span>
            <span class="text-truncate" style="color: #719eb6">{{
              getLabelForAlarmOption(getAlarmOption())
            }}</span>
          </div>
        </div>
        <div class="col-6">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6">Alarm Sound:</span>
            <span class="text-truncate" style="color: #719eb6"
              >{{ getAlarmSound() }}
              <i
                class="pi pi-play"
                style="color: #719eb6; cursor: pointer"
                (click)="playAlarmSound()"
              ></i>
            </span>
          </div>
        </div>
      </div>
      }

      <!-- Half width rows -->
      @if(requiresDuration()){
      <div class="row mb-2">
        <div class="col-6">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6">Duration (Goal):</span>
            <span class="text-truncate" style="color: #719eb6">{{
              getDurationInMinutes() + " minutes"
            }}</span>
          </div>
        </div>
        <!-- <div class="col-6">
            <div class="d-flex justify-content-between align-items-center mx-3">
              <span class="fw-bold" style="color: #719eb6"
                >Last Changed Date:</span
              >
              <span class="text-truncate" style="color: #719eb6">{{
                target?.LastChangedDate | date
              }}</span>
            </div>
          </div> -->
      </div>
      }

      <!-- Half width rows -->
      <div class="row mb-2 position-relative">
        <div class="col-6">
          <div
            class="d-flex justify-content-start align-items-center mx-3"
            role="button"
            (click)="toggleInstructionEdit($event)"
          >
            <span class="fw-bold" style="color: #719eb6"
              >Target Instructions:</span
            >
            <div style="color: #719eb6; margin-left: 5px">
              <i class="pi pi-pencil m-0 p-0"></i>
            </div>
          </div>
        </div>
        <div class="col-6" *ngIf="false">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6">Auto-Open Order:</span>
            <span class="text-truncate" style="color: #719eb6">{{ "?" }}</span>
          </div>
        </div>
        @if(showInstructionsEdit){
        <div
          class="target-status-edit"
          (clickOutside)="closeInstructionsEdit($event)"
        >
          <i
            class="target-status-edit-close"
            role="button"
            (click)="toggleInstructionEdit($event)"
            >x</i
          >
          <div class="control-row">
            <div class="control no-margin">
              <label for="targetStatus">Target Instructions:</label>
              <ckeditor
                id="newInstructions"
                name="newInstructions"
                [editor]="Editor"
                [config]="editorConfig"
                [data]="newInstructions"
                (change)="onInstructionsChange($event)"
              ></ckeditor>
            </div>
            <button
              class="btn btn-primary float-right mt-2"
              style="color: #ffffff"
              (click)="updateTargetInstructions()"
            >
              Update
            </button>
          </div>
        </div>
        }
      </div>
      <app-add-attachment-modal
        [showAddAttachments]="showAddAttachments"
        [view]="'targetAttachment'"
        [id]="target?.ID ?? 0"
        [targetID]="target?.ID ?? 0"
        (close)="closeAddAttachments()"
      ></app-add-attachment-modal>
      <app-attachment-view
        [doShowAttachmentView]="doShowAttachmentView"
        [attachment]="selectedAttachment"
        [canDelete]="true"
        [view]="'targetAttachment'"
        (close)="closeAttachmentView()"
      ></app-attachment-view>
      @if(target?.ID != null && target?.ID != 0){

      <div class="row">
        <div
          class="col-lg-9 col-md-12 m-0 p-0 mb-2 d-flex justify-content-start align-items-end"
        >
          <button
            class="btn btn-secondary float-right"
            style="height: 35px; margin-top: 15px; margin-left: 30px"
            type="button"
            (click)="toggleShowAddAttachments()"
            [disabled]="isLoading"
          >
            <i class="m-0 p-0 pi pi-paperclip"></i>&nbsp;&nbsp;Add Attachments
          </button>
        </div>
        <div class="col-12">
          <div class="att-list-container" style="margin-top: 0px">
            @if(isLoadingAttachments){
            <div class="att-box">
              <i class="m-0 p-0 pi pi-spinner pi-spin"></i>
            </div>
            } @else{ @for (att of attachmentList; track att.ID) {
            <div
              class="att-box"
              role="button"
              (click)="openAttachmentView(att)"
            >
              @if(att.IsImage){
              <img
                class="m-2"
                [src]="getImageUrl(att)"
                style="
                  min-width: 40px;
                  min-height: 40px;
                  max-width: 40px;
                  max-height: 40px;
                "
              />
              } @else{
              <i class="m-0 p-0 pi pi-file-o" style="font-size: 25px"></i>
              }
            </div>
            } }
          </div>
        </div>
      </div>
      }

      <!-- Full width rows -->
      <div class="row mb-2 position-relative">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <div
              class="ck ck-content text-wrap target-instructions"
              style="
                background-color: #e1e8fb;
                color: #719eb6;
                border-radius: 10px;
                padding: 10px;
                margin: 0;
                width: 100%;
              "
              [innerHTML]="target?.Instructions || 'None'"
            ></div>
          </div>
        </div>
      </div>

      @if (shouldDisplaySubtargetsList()) {
      <!-- Full width rows -->
      <div class="row mb-2">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6">Sub-Targets:</span>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-12">
          <div class="d-flex justify-content-between mx-3 subtargets-list">
            <div class="col-12">
              @for (subtarget of getSubtargetsList(); track subtarget.ID) {
              <app-target
                [patientID]="patientID()"
                [target]="subtarget"
                [id]="subtarget.TargetName"
              />
              }
            </div>
          </div>
        </div>
      </div>
      }
    </div>

    <div class="col-2">
      <div class="d-flex flex-column gap-2">
        <button
          pButton
          id="editTargetButton-{{ target?.TargetName }}"
          class="p-button-outlined side-menu-button2 m-2"
          [disabled]="target?.IsDeleted"
          [style.opacity]="target?.IsDeleted ? '0.5' : '1'"
          [style.cursor]="target?.IsDeleted ? 'not-allowed' : 'pointer'"
          icon="pi pi-pencil"
          label="Edit"
          (click)="editTarget()"
        ></button>

        <button
          pButton
          class="p-button-outlined side-menu-button2 m-2"
          icon="pi pi-history"
          label="Change Log"
          (click)="showChangeLog()"
          [style.opacity]="'1'"
          [style.cursor]="'pointer'"
        ></button>

        <button
          pButton
          class="p-button-outlined side-menu-button2 m-2"
          icon="pi pi-file-excel"
          label="Raw Data"
          (click)="onShowDataClicked()"
          [style.opacity]="'1'"
          [style.cursor]="'pointer'"
        ></button>

        <button
          pButton
          *ngIf="canPlotGraph"
          class="p-button-outlined side-menu-button2 m-2"
          icon="pi pi-chart-line"
          label="Graph"
          (click)="onShowGraphClicked()"
        ></button>

        <button
          pButton
          class="p-button-outlined side-menu-button2 m-2"
          icon="pi pi-copy"
          label="Duplicate"
          (click)="duplicateTarget()"
        ></button>
        @if(!target?.IsArchived && !target?.IsDeleted){
        <button
          pButton
          class="p-button-outlined button-warning m-2"
          icon="pi pi-times-circle"
          label="Archive"
          [disabled]="target?.IsArchived"
          [style.opacity]="target?.IsArchived ? '0.5' : '1'"
          [style.cursor]="target?.IsArchived ? 'not-allowed' : 'pointer'"
          (click)="doArchiveTarget()"
        ></button>
        <button
          pButton
          class="p-button-outlined p-button-danger switch-mode-button m-2"
          icon="pi pi-trash"
          label="Delete"
          id="deleteTargetButton-{{ target?.TargetName }}"
          [disabled]="target?.IsDeleted"
          [style.opacity]="target?.IsDeleted ? '0.5' : '1'"
          [style.cursor]="target?.IsDeleted ? 'not-allowed' : 'pointer'"
          (click)="deleteTarget()"
        ></button>
        }
        <button
          *ngIf="
            canRestoreTargets() && (target?.IsDeleted || target?.IsArchived)
          "
          pButton
          class="p-button-outlined button-restore m-2"
          icon="pi pi-undo"
          label="Restore"
          [disabled]="!target?.IsDeleted && !target?.IsArchived"
          [style.opacity]="
            !target?.IsDeleted && !target?.IsArchived ? '0.5' : '1'
          "
          [style.cursor]="
            !target?.IsDeleted && !target?.IsArchived
              ? 'not-allowed'
              : 'pointer'
          "
          (click)="restoreTarget()"
        ></button>
      </div>
    </div>

    <!-- Full width notes section -->
    <div class="col-12 mt-3">
      <div class="mx-3">
        <div class="d-flex justify-content-between align-items-center">
          <span class="fw-bold" style="color: #719eb6"
            >Target Notes:
            <i style="font-size: 12px; opacity: 0.5">{{
              lastModifiedByText() +
                (target?.NotesLastModifiedDate != null
                  ? (target?.NotesLastModifiedDate
                    | date : "MM/dd/yyyy hh:mm a")
                  : "")
            }}</i></span
          >
          <div class="d-flex gap-2">
            <button
              *ngIf="!isEditingTargetNotes"
              pButton
              class="p-button-outlined side-menu-button2"
              icon="pi pi-pencil"
              (click)="startEditingTargetNotes()"
            >
              &nbsp;Edit
            </button>
            <div *ngIf="isEditingTargetNotes" class="d-flex gap-2">
              <button
                pButton
                class="p-button-outlined side-menu-button2"
                icon="pi pi-check"
                (click)="saveTargetNotes()"
              >
                &nbsp;Save
              </button>
              <button
                pButton
                class="p-button-outlined switch-mode-button"
                icon="pi pi-times"
                (click)="cancelEditingTargetNotes()"
              >
                &nbsp;Cancel
              </button>
            </div>
          </div>
        </div>
        <textarea
          pTextarea
          [disabled]="!isEditingTargetNotes"
          [(ngModel)]="target!.TargetNotes"
          rows="3"
          style="width: 100%; margin-top: 0.5rem"
        ></textarea>
      </div>
    </div>
  </div>

  <app-change-log-modal
    #changeLogModal
    [entityID]="target?.ID ?? null"
    [entityType]="entityTypeTarget"
    [entityName]="target?.TargetName ?? ''"
    [defaultFilter]="'all'"
    [showFilterToggle]="false"
  ></app-change-log-modal>
</div>
}
